import {AvailableTrafficPack} from '../interfaces/available-traffic-pack';
import {TrafficPackHistoryItem} from '../interfaces/traffic-pack-history-item';
import {ActivePack} from '../interfaces/active-pack';

export class DashboardSubscriptionsModel {
  availableTrafficPacks: AvailableTrafficPack[] = [];
  trafficPacksHistory: TrafficPackHistoryItem[] = [];
  activePack: ActivePack | undefined = undefined;

  public saveAvailableTrafficPacks(response: AvailableTrafficPack[]): DashboardSubscriptionsModel {
    this.availableTrafficPacks = response;

    return this;
  }

  public saveTrafficPacksHistory(response: TrafficPackHistoryItem[]): DashboardSubscriptionsModel {
    this.trafficPacksHistory = response;

    return this;
  }

  public saveActivePack(response: ActivePack): DashboardSubscriptionsModel {
    this.activePack = response;

    return this;
  }

}
